"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiversityOverlayProvider = exports.DiversityOverlayContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const models_1 = require("@completeanatomy/models");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("../../../utils");
const hooks_1 = require("../../hooks");
const setIsOnboarding_1 = require("./actions/setIsOnboarding");
const setPreviewImage_1 = require("./actions/setPreviewImage");
const setSelectedPhenotype_1 = require("./actions/setSelectedPhenotype");
const setSelectedSex_1 = require("./actions/setSelectedSex");
const setSkinTone_1 = require("./actions/setSkinTone");
const reducer_1 = require("./reducer");
const state_1 = require("./state");
exports.DiversityOverlayContext = (0, react_1.createContext)(null);
function DiversityOverlayProvider({ children, }) {
    const diversity = (0, hooks_1.useDiversityKey)();
    const selectedModelType = (0, models_1.useModelType)();
    const location = (0, react_router_dom_1.useLocation)();
    const bridge = (0, bridge_1.useBridge)();
    const [state, dispatch] = (0, react_1.useReducer)(reducer_1.reducer, state_1.initialState);
    const { selectedPhenotype, selectedSkinTone, selectedSex } = state;
    const selectedModelSex = selectedModelType === bridge_schema_1.ModelType.Male ? 'male' : 'female';
    const modelSave = (isSkipping = false) => {
        let modelType;
        if (isSkipping) {
            const { randomPhenotype, randomSkinTone, randomSex } = (0, utils_1.getRandomModelValue)();
            dispatch((0, setPreviewImage_1.setPreviewImage)(`${randomSex}_head_${randomPhenotype}-${randomSkinTone}`));
            dispatch((0, setSelectedPhenotype_1.setSelectedPhenotype)(randomPhenotype));
            dispatch((0, setSelectedSex_1.setSelectedSex)(randomSex));
            dispatch((0, setSkinTone_1.setSkinTone)(randomSkinTone));
            modelType = randomSex === 'female' ? bridge_schema_1.ModelType.Female : bridge_schema_1.ModelType.Male;
        }
        else {
            modelType = selectedSex === 'female' ? bridge_schema_1.ModelType.Female : bridge_schema_1.ModelType.Male;
        }
        const tempDiversityKey = `${selectedPhenotype}-${selectedSkinTone}`;
        bridge === null || bridge === void 0 ? void 0 : bridge.changeDiversityWithOptions({
            diversityKey: tempDiversityKey,
            modelType,
        });
    };
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.isOpenFirst) {
            dispatch((0, setIsOnboarding_1.setIsOnboarding)((_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.isOpenFirst));
        }
    }, [location === null || location === void 0 ? void 0 : location.state]);
    (0, react_1.useEffect)(() => {
        dispatch((0, setPreviewImage_1.setPreviewImage)(diversity ? `${selectedModelSex}_head_${diversity}` : ''));
        dispatch((0, setSelectedPhenotype_1.setSelectedPhenotype)(diversity ? diversity.split('-')[0] : ''));
        dispatch((0, setSelectedSex_1.setSelectedSex)(diversity ? selectedModelSex : ''));
        dispatch((0, setSkinTone_1.setSkinTone)(diversity ? diversity.split('-')[1] : ''));
    }, [diversity, selectedModelSex]);
    return ((0, jsx_runtime_1.jsx)(exports.DiversityOverlayContext.Provider, { value: { state, dispatch, modelSave }, children: children }));
}
exports.DiversityOverlayProvider = DiversityOverlayProvider;
